import * as React from "react";
import Modal from "../../ui/modal/Modal";
import FormButtonsView from "../../ui/form/FormButtonsView";
import Input from "../../../hiberUiKit/src/atoms/Input/Input";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import MarkdownEditor from "../../markdown/MarkdownEditor";
import * as Showdown from "showdown";

interface IComponentProps {
	/**
	 * Send message button click callback.
	 * @param {string} subject
	 * @param {string} message
	 */
	onMessageSend: (subject: string, message: string) => void;
	/**
	 * Close modal callback.
	 */
	onClose: () => void;
	/**
	 * Modal title
	 */
	title: string;
}

interface IState {
	/**
	 * Subject
	 */
	subject: string
	/**
	 * Message content.
	 */
	emailMarkdownContent: string;
}

type Props = IComponentProps

export default class EmailMessageModal extends React.PureComponent<Props, IState> {

	converter: Showdown.Converter;

	constructor(props: Props) {
		super(props);
		this.state = {
			subject: "",
			emailMarkdownContent: ""
		};
		this.converter = new Showdown.Converter({
			tables: true,
			simplifiedAutoLink: true,
			strikethrough: true,
			tasklists: true,
			extensions: ["styled-elements", "check-mark-list"],
			noHeaderId: true,
		});
		this.onSubjectChange = this.onSubjectChange.bind(this);
		this.onContentChange = this.onContentChange.bind(this);
		this.sendEmail = this.sendEmail.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} title={this.props.title} fixedWidth>
				<div className={"c-email-message-modal"}>
					<Input type={"text"}
						   placeholder={"Subject"}
						   value={this.state.subject}
						   onChange={this.onSubjectChange}/>
					<MarkdownEditor maxEditorHeight={400} minEditorHeight={400} minPreviewHeight={400}
									onChange={this.onContentChange}
									markdown={this.state.emailMarkdownContent}
									disabled={false}/>
					<FormButtonsView align={"right"}>
						<div style={{paddingTop: "20px"}}>
							<div className="pull-left">
								<ButtonTertiary label="Cancel"
												onClick={this.props.onClose}/>
							</div>
							<ButtonPrimary label={"Send"}
										   onClick={this.sendEmail}
										   disabled={!(this.state.emailMarkdownContent.trim().length &&
											   this.state.subject.trim().length)}/>
						</div>
					</FormButtonsView>
				</div>
			</Modal>
		)
	}

	private onContentChange(emailMarkdownContent: string) {
		this.setState({emailMarkdownContent});
	}

	private onSubjectChange(evt: React.ChangeEvent<HTMLInputElement>) {
		this.setState({subject: evt.target.value});
	}

	sendEmail() {
		const html = this.converter.makeHtml(this.state.emailMarkdownContent);
		this.props.onMessageSend(this.state.subject.trim(), html);
	}
}